import script from "./CommandCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./CommandCenter.vue?vue&type=script&setup=true&lang=js"

import "./CommandCenter.vue?vue&type=style&index=0&id=4250085c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4250085c"]])

export default __exports__